export default __webpack_public_path__ + "static/media/GroundMac_Logo_Negativo.200dd395.png";